import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDotCrossedDarkIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Warstwa_1",
	"data-name": "Warstwa 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n            .cls-1 {\n            fill: none;\n            stroke: #fff;\n            stroke-linecap: round;\n            stroke-miterlimit: 10;\n            stroke-width: 1.5px;\n            }\n\n            .cls-2 {\n            fill: #1e1f2c;\n            }\n        " }) }),
		/* @__PURE__ */ _jsx("circle", {
			className: "cls-2",
			cx: 10,
			cy: 10,
			r: 10
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 6.59,
			y1: 6.59,
			x2: 13.41,
			y2: 13.41
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "cls-1",
			x1: 13.41,
			y1: 6.59,
			x2: 6.59,
			y2: 13.41
		})
	]
});
export default SvgDotCrossedDarkIcon;
